
    import './styles.scoped.css';
    export default {
  "block-body-scroll": "awsui_block-body-scroll_19d8l_1nc9q_103",
  "mobile-bar": "awsui_mobile-bar_19d8l_1nc9q_107",
  "mobile-bar-breadcrumbs": "awsui_mobile-bar-breadcrumbs_19d8l_1nc9q_120",
  "mobile-toggle": "awsui_mobile-toggle_19d8l_1nc9q_127",
  "mobile-toggle-type-navigation": "awsui_mobile-toggle-type-navigation_19d8l_1nc9q_136",
  "mobile-toggle-type-tools": "awsui_mobile-toggle-type-tools_19d8l_1nc9q_139",
  "mobile-toggle-type-drawer": "awsui_mobile-toggle-type-drawer_19d8l_1nc9q_139",
  "drawers-container": "awsui_drawers-container_19d8l_1nc9q_146"
};
  